module.exports = __webpack_public_path__ + "static/p-6-e0449986d9b888e9c427e3e8e95d9882.jpg";